/**
 * Имя query-параметра, которым список нод знаний фильтруется по источнику.
 * Контракт адреса задан здесь один раз: и чтение фильтра страницей, и сборка ссылок на него идут через этот модуль
 */
export const KNOWLEDGE_SOURCE_FILTER_PARAM = 'sourceId';

/**
 * Возвращает идентификатор источника из параметров адреса.
 * `undefined` — фильтр не задан либо значение в адресе не является идентификатором
 */
export const parseKnowledgeSourceFilter = (params: URLSearchParams): number | undefined => {
  const sourceId = Number(params.get(KNOWLEDGE_SOURCE_FILTER_PARAM));

  return Number.isInteger(sourceId) && sourceId > 0 ? sourceId : undefined;
};

/**
 * Собирает адрес списка нод знаний, отфильтрованного по источнику.
 * Прочие параметры адреса переносятся, чтобы ссылка несла состояние страницы целиком
 */
export const buildKnowledgeSourceFilterPath = (sourceId: number, currentParams?: URLSearchParams): string => {
  const params = new URLSearchParams(currentParams);
  params.set(KNOWLEDGE_SOURCE_FILTER_PARAM, String(sourceId));

  return `/knowledge?${params.toString()}`;
};
